const userData = (state, action) => {
  if (!state) {
    return {
      hotels: [],
      hotelInfo: {}
    }
  }

  switch (action.type) {
  case 'HOTELS':
    return { ...state, hotels: action.hotels }
  case 'HOTELINFO':
    return { ...state, hotelInfo: action.hotelInfo }
  default:
    return state
  }
}

export default userData


// WEBPACK FOOTER //
// ./src/reducer/user.js